import { ElementType, PropsWithChildren, useContext } from "react";

import { motion } from "motion/react";

import { PolymorphicProps } from "shared/types";
import { cn } from "shared/utils/cn";

import { TabsContext } from "./context";
import { tabVariants, TabVariantsProps } from "./styles";

type Props = {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
} & TabVariantsProps;

export const Tab = <E extends ElementType = "li">(
  props: PropsWithChildren<PolymorphicProps<E, Props>>
) => {
  const {
    as: Comp = motion.li,
    children,
    className,
    isActive: isActiveProp = false,
    onClick,
    disabled,
    ...restProps
  } = props;

  const { lineLayoutId, variant } = useContext(TabsContext);

  const isActive = isActiveProp;

  return (
    <Comp
      className={cn(tabVariants({ className, variant, isActive }))}
      onClick={onClick}
      style={{
        WebkitTapHighlightColor: "transparent",
      }}
      {...restProps}
    >
      {children}
      {isActive && (
        <motion.span
          className="bg-persianOrange absolute inset-x-0 -bottom-px z-20 h-0.5"
          layoutId={`line-${lineLayoutId}`}
          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
        />
      )}
    </Comp>
  );
};
